import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { upsertCharacteristics } from '@services/shoppingCartService';
import { cartQueryKey } from '@hooks/useCart/useCart';
import type { CharacteristicDTO, ShoppingCartDTO } from '@t/api.types';

export interface UpsertCharacteristicsVariables {
  itemId: string;
  characteristics: CharacteristicDTO[];
}

interface UseUpsertCharacteristicsOptions {
  onError?: (error: Error) => void;
}

export const useUpsertCharacteristics = (
  sessionId: string,
  { onError }: UseUpsertCharacteristicsOptions = {}
): UseMutationResult<ShoppingCartDTO, Error, UpsertCharacteristicsVariables> => {
  const queryClient = useQueryClient();
  return useMutation<ShoppingCartDTO, Error, UpsertCharacteristicsVariables>({
    mutationFn: ({ itemId, characteristics }) => upsertCharacteristics(sessionId, itemId, characteristics),
    onSuccess: (cart) => queryClient.setQueryData<ShoppingCartDTO>(cartQueryKey(sessionId), cart),
    onError,
  });
};
